// Shared constants for the SheetsSync UI. Extracted to keep the parent page
// focused on orchestration and let sub-components consume them freely.

export const STATUS_META = {
  will_update: { label: "Akan Update", cls: "bg-emerald-100 text-emerald-800 border-emerald-500" },
  mismatch: { label: "Mismatch", cls: "bg-red-100 text-red-800 border-red-500" },
  not_found: { label: "Tidak Ditemukan", cls: "bg-amber-100 text-amber-800 border-amber-500" },
  unchanged: { label: "Sudah Sesuai", cls: "bg-secondary text-muted-foreground border-border" },
  already_verified: { label: "Sudah Verified", cls: "bg-blue-100 text-blue-800 border-blue-500" },
  skipped: { label: "Dilewati", cls: "bg-secondary text-muted-foreground border-border" },
  error: { label: "Error", cls: "bg-red-100 text-red-800 border-red-500" },
};

// Field labels shown in the mapping dialog (Indonesian, user-friendly)
export const MAPPING_FIELD_LABELS = {
  no_polisi: "No Polisi",
  nama_barang: "Jenis Barang",
  jumlah: "Quantity",
  distrik: "Distrik",
  no_spb: "No SPB",
  no_so: "No SO",
};

// Sentinel for the "don't map" option in the mapping dialog. `SelectItem`
// cannot have an empty-string value (Radix throws), so we use a magic token
// and convert to "" before persisting.
export const UNMAPPED = "__unmapped__";
